import React, { useState } from 'react';
import { useEscapeKey } from '../../hooks/useEscapeKey';
import { X } from 'lucide-react';
import { useForm } from 'react-hook-form';

interface AddEngagementStepPopupProps {
  onClose: () => void;
  onSave: (data: { name: string; description?: string }) => void;
  currentStepCount: number;
}

interface StepFormData {
  name: string;
  description?: string;
}

export default function AddEngagementStepPopup({
  onClose,
  onSave,
  currentStepCount
}: AddEngagementStepPopupProps) {
  useEscapeKey(onClose);
  const { register, handleSubmit, formState: { errors } } = useForm<StepFormData>();

  const onSubmit = (data: StepFormData) => {
    onSave(data);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-dark-800 rounded-lg w-full max-w-md">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-dark-600">
          <h2 className="text-xl font-semibold text-white">Add Engagement Step</h2>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-white"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit(onSubmit)} className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-400 mb-1">
              Step Name*
            </label>
            <input
              {...register('name', { required: 'Step name is required' })}
              className="input w-full"
              placeholder="e.g., Break the Ice"
            />
            {errors.name && (
              <p className="mt-1 text-sm text-red-500">{errors.name.message}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-400 mb-1">
              Description (Optional)
            </label>
            <textarea
              {...register('description')}
              className="input w-full h-24 resize-none"
              placeholder="Describe what this step entails..."
            />
          </div>

          <div className="text-sm text-gray-400">
            This step will be added as step #{currentStepCount + 1}
          </div>

          {/* Footer */}
          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="btn btn-secondary"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
            >
              Add Step
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
